import { apiGet, apiPost } from '@/lib/http/client';

import type { SalesforceInstallResponse } from '../types';

export async function disconnectSalesforce(
  orgId: number | string
): Promise<{ success: boolean }> {
  return apiPost<{ success: boolean }>(
    `/api/orgs/${orgId}/salesforce/disconnect/`,
    {}
  );
}

/**
 * Fetch the Salesforce authorize URL, then navigate to it — the caller does the
 * navigating (mirrors `getHubspotInstallUrl`).
 *
 * This must NOT go back to returning a bare relative path for the browser to
 * follow: a relative url resolves against the SPA's own origin, where Django is
 * not served, so Connect dead-ended on a blank page wherever the SPA and API
 * origins differ. `apiGet` resolves the path against the API base url, which is
 * the whole point.
 *
 * The endpoint lives under `/accounts/` rather than `/api/orgs/<id>/` because the
 * local-proxy oauth-gateway only routes `/accounts/*`, and this request must land
 * on the same instance as the callback — it writes the PKCE verifier into the
 * session the callback pops.
 */
export async function getSalesforceInstallUrl(
  orgId: number | string,
  loginHost: string
): Promise<SalesforceInstallResponse> {
  return apiGet<SalesforceInstallResponse>('/accounts/salesforce/install/', {
    org_id: String(orgId),
    login_host: loginHost,
  });
}
